<template>
  <v-layout row class="mexp-full-flex grey lighten-2" align-center>
    <v-flex text-xs-center align-content-center>
      <div :class="expClass">
        Projects
      </div>
      <v-container>

      </v-container>
      <v-container grid-list-md align-center justify-center>
        <v-layout fill-height row wrap>
          <v-flex xs12 sm6 md4 text-xs-center
                  v-for="(e,i) in experiences" :key="i"
          >
            <v-card flat>
              <!--<v-card-media-->
                <!--:src="e.src"-->
                <!--height="200px"-->
              <!--&gt;-->
              <!--</v-card-media>-->

              <v-card-title primary-title>
                <div class="headline text--darken-2 grey--text">
                  {{e.txt}}
                </div>
              </v-card-title>

              <v-card-media>
                <div v-for="l in e.lang" :key="l">
                  <i class="devicon-git-plain colored text--darken-2 grey--text"></i>
                </div>
              </v-card-media>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: "Experience",
    computed: {
      expClass() {
        return {
          "grey--text": true,
          "text--darken-2": true,
          "display-4": this.$vuetify.breakpoint.mdAndUp,
          "display-2": this.$vuetify.breakpoint.smAndDown,
        }
      }
    },
    methods:{
      getIcon(name) {
      }
    },
    data() {
      return {
        experiences: [
          {
            txt: "LayZLiving",
            lang: ["Java", "Spring Boot", "ReactJS", "Docker", "Arduino", "DroneCI", "MySQL"],
            src: '/static/projects/lzlv.png'
          },
          {
            txt: "Makeup Scheduler",
            lang: ["Google Firebase", "VueJS", "CircleCI"],
            src: '/static/projects/msched.jpg'
          },
          {
            txt: "NuttapatK's",
            lang: ["VueJS", "Docker", "CircleCI"],
            src: '/static/projects/nk.jpg'
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .mexp-full-flex {
    height: 100vh;
    width: 100%;
    min-width: 100%;
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/desktop/exp/Experience.vue